import React, { useEffect, useState } from "react";
import { ToastContainer, Id } from "react-toastify";
import { defaultToastOptions, mobileToastOptions } from "../../../utils/toast";
import "./ToastAlert.styles.css";
import clx from "classnames";

function useIsDarkMode() {
  const [isDark, setIsDark] = useState(() =>
    document.documentElement.classList.contains("dark"),
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.documentElement.classList.contains("dark"));
    });
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  return isDark;
}

export type ToastAlertContainerType = "mobile" | "desktop";
type ToastAlertContainerProps = {
  containerId: Id;
};

export const ToastAlertDesktopContainer = ({
  containerId,
}: ToastAlertContainerProps) => {
  const isDarkMode = useIsDarkMode();

  return (
    <ToastContainer
      containerId={containerId}
      limit={3}
      {...defaultToastOptions}
      theme={isDarkMode ? "dark" : "light"}
      className={clx("toast", "desktop-toast-container")}
    />
  );
};

export const ToastAlertMobileContainer = ({
  containerId,
}: ToastAlertContainerProps) => {
  const isDarkMode = useIsDarkMode();

  return (
    <ToastContainer
      containerId={containerId}
      limit={3}
      stacked={true}
      theme={isDarkMode ? "dark" : "colored"}
      {...mobileToastOptions}
      className={clx("toast", "mobile-toast")}
      style={{
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
      toastStyle={{
        width: "70%",
        borderRadius: "8px",
        padding: "8px",
      }}
    />
  );
};
